import { groupBy, keys, map } from 'lodash-es'
import { SCRAPING_TAG_TYPES } from '../constants'

const formatScrapingTags = scrapingTags => {
  const tagsByType = groupBy(scrapingTags, 'type')

  return map(
    keys(tagsByType),
    tagType =>
      `${SCRAPING_TAG_TYPES[tagType].name}: ${map(
        tagsByType[tagType],
        tag => tag.name,
      ).join(', ')}`,
  )
}

export default formatScrapingTags
